import api from './api';

export const multiCurrencyService = {
  getRates: async (params = {}) => {
    try {
      const response = await api.get('/finance/currency/rates', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createRate: async (data) => {
    try {
      const response = await api.post('/finance/currency/rates', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateRate: async (rateId, data) => {
    try {
      const response = await api.put(`/finance/currency/rates/${rateId}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getHedgingStrategies: async () => {
    try {
      const response = await api.get('/finance/currency/hedging');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getTaxCompliance: async (currency) => {
    try {
      const response = await api.get('/finance/currency/tax-compliance', { params: { currency } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  convertAmount: async (data) => {
    try {
      const response = await api.post('/finance/currency/convert', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getRealTimeRates: async (baseCurrency = 'USD', targetCurrencies = []) => {
    try {
      const params = { baseCurrency };
      if (targetCurrencies && targetCurrencies.length > 0) {
        params.targetCurrencies = targetCurrencies.join(',');
      }
      const response = await api.get('/finance/currency/rates/realtime', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  syncRealTimeRates: async (baseCurrency = 'USD', targetCurrencies = []) => {
    try {
      const response = await api.post('/finance/currency/rates/sync', {
        baseCurrency,
        targetCurrencies
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getSupportedCurrencies: async () => {
    try {
      const response = await api.get('/finance/currency/currencies/supported');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};